import styled from '@emotion/styled';

export const FormLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;
